import React, { useEffect, useRef, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { useSelector } from 'react-redux';
import FullPageLoader from '~/components/FullPageLoader/FullPageLoader.tsx';
import { useAppDispatch } from '~/store/appDispatch.ts';
import {
  getPersonalDataTableRevoke,
  getPersonalDataTableSubmit,
} from '~/store/processing-personal/thunks/personalDataTableThunks.ts';
import PersonalDataTableSubmit from './PersonalDataTable/PersonalDataTableSubmit/PersonalDataTableSubmit.tsx';
import PersonalDataTableRevoke from './PersonalDataTable/PersonalDataTableRevoke/PersonalDataTableRevoke.tsx';
import { SearchDataTable } from './PersonalDataTable/components/SearchDataTable.tsx';
import { RootState } from '~/store/store.ts';
import { BoxSVG } from './PersonalDataTable/components/BoxSVG.tsx';
import { TRevokeApplicationsResponse, TApplicationsResponse } from './types.ts';
import {
  personalDataTabSx,
  personalDataTabsSx,
  personalDataTabsWrapperSx,
} from './PersonalDataTable/styles.ts';
import { DEFAULT_PERSONAL_DATA_TABLE_PAGINATION } from './PersonalDataTable/constants.ts';

export default function PersonalDataMainTable() {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const initialDataRequested = useRef(false);

  const [activeTab, setActiveTab] = useState<'1' | '2'>('1');

  const submitTableData = useSelector(
    (state: RootState) =>
      state.processingPersonal.personalDataTableSubmit as TApplicationsResponse | null
  );

  const revokeTableData = useSelector(
    (state: RootState) =>
      state.processingPersonal.personalDataTableRevoke as TRevokeApplicationsResponse | null
  );

  const pendingSubmitTable = useSelector(
    (state: RootState) => state.processingPersonal.pendingPersonalDataTableSubmit
  );
  const pendingRevokeTable = useSelector(
    (state: RootState) => state.processingPersonal.pendingPersonalDataTableRevoke
  );

  const contentSubmit = submitTableData?.applications ?? [];
  const contentRevoke = revokeTableData?.applications ?? [];

  useEffect(() => {
    if (initialDataRequested.current || pendingSubmitTable || pendingRevokeTable) return;

    initialDataRequested.current = true;

    if (!submitTableData) {
      void dispatch(getPersonalDataTableSubmit({ data: DEFAULT_PERSONAL_DATA_TABLE_PAGINATION }));
    }

    if (!revokeTableData) {
      void dispatch(getPersonalDataTableRevoke({ data: DEFAULT_PERSONAL_DATA_TABLE_PAGINATION }));
    }
  }, [dispatch, pendingRevokeTable, pendingSubmitTable, revokeTableData, submitTableData]);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: '1' | '2') => {
    setActiveTab(newValue);
  };

  return (
    <Box>
      {isLoading && <FullPageLoader />}

      <SearchDataTable onLoading={setIsLoading} />

      <Box sx={personalDataTabsWrapperSx}>
        <Tabs value={activeTab} onChange={handleTabChange} sx={personalDataTabsSx}>
          <Tab label="Заявки в обробці" value="1" sx={personalDataTabSx} />
          <Tab label="Відкликані заявки" value="2" sx={personalDataTabSx} />
        </Tabs>
      </Box>

      {activeTab === '1' && (
        <PersonalDataTableSubmit
          content={contentSubmit}
          pageConfiguration={submitTableData?.pageConfiguration}
          BoxSVG={BoxSVG}
          onLoading={setIsLoading}
        />
      )}

      {activeTab === '2' && (
        <PersonalDataTableRevoke
          content={contentRevoke}
          pageConfiguration={revokeTableData?.pageConfiguration}
          BoxSVG={BoxSVG}
          onLoading={setIsLoading}
        />
      )}
    </Box>
  );
}
